import React from 'react';
import { ReactComponent as  EN} from 'assets/images/CardsEng.svg';
import { ReactComponent as  RU } from 'assets/images/CardsRus.svg';
import Back from 'assets/images/background2.png';
import {useParams} from "react-router-dom";
import c from './index.module.scss'
const RightCard = () => {
    const {lang} = useParams();
    return (
        <div
            className={c.left_card}
            style={{
                background: `url(${Back}) #F9F7FF no-repeat bottom`,
            }}
        >
            {lang === 'ru' ?
                <RU/>
                :
                <EN />
            }
        </div>
    );
};

export default RightCard;